// extracted by mini-css-extract-plugin
export var cartContainer = "_i2-4";
export var gray = "_i2-1";
export var itemContainer = "_i2-2";
export var itemDetails = "_i2-3";
export var strong = "_i2-0";